export default class StateManager {

  static DOC_ALL_WORKERS_DASHBOARD = 'DOC_ALL_WORKERS_DASHBOARD';
  static DOC_ALL_MACHINES_DASHBOARD = 'DOC_ALL_MACHINES_DASHBOARD';
  static DOC_MONTHLY_DASHBOARD = 'DOC_MONTHLY_DASHBOARD';
  static DOC_OUTOSOURCE_DASHBOARD = 'DOC_OUTOSOURCE_DASHBOARD';
  static DOC_LINKED_DASHBOARD = 'DOC_LINKED_DASHBOARD';
  static DOC_ALL_COMPANY_DASHBOARD = 'DOC_ALL_COMPANY_DASHBOARD';
  static DOC_ALL_DASHBOARD = 'DOC_ALL_DASHBOARD';

  static DOC_ALL_WORKERS_DOCUMENTS = 'DOC_ALL_WORKERS_DOCUMENTS';
  static DOC_ALL_MACHINES_DOCUMENTS = 'DOC_ALL_MACHINES_DOCUMENTS';
  static DOC_ALL_OUTSOURCES_DOCUMENTS = 'DOC_ALL_OUTSOURCES_DOCUMENTS';
  static DOC_ALL_WORKS_DOCUMENTS = 'DOC_ALL_WORKS_DOCUMENTS';
  static DOC_MONTHLY_DOCUMENTS = 'DOC_MONTHLY_DOCUMENTS';

  static DOC_ALL_WORKERS = 'DOC_ALL_WORKERS';
  static DOC_ALL_WORKERS_OUTSOURCE_DETAIL_ID = 'DOC_ALL_WORKERS_OUTSOURCE_DETAIL_ID';
  static DOC_ALL_MACHINES_OUTSOURCE_DETAIL_ID = 'DOC_ALL_MACHINES_OUTSOURCE_DETAIL_ID';
  static DOC_WORKER_DETAIL_ID = 'DOC_WORKER_DETAIL_';
  static DOC_ALL_MACHINES = 'DOC_ALL_MACHINES';
  static DOC_MACHINE_DETAIL_ID = 'DOC_MACHINE_DETAIL_';
  static DOC_ALL_WORKS = 'DOC_ALL_WORKS';
  static DOC_WORK_EDIT = 'DOC_WORK_EDIT';
  static DOC_MONTHLY = 'DOC_MONTHLY';
  static DOC_OUTSOURCE_DETAIL_ID = 'DOC_OUTSOURCE_DETAIL_';
  static DOC_MONTHLY_OUTSOURCE_DETAIL_ID = 'DOC_MONTHLY_OUTSOURCE_DETAIL_';
  static DOC_LINKED_OUTSOURCE_DETAIL_ID = 'DOC_LINKED_OUTSOURCE_DETAIL_ID';

  static EXP_DOC_TAB_OUTSOURCE = 'EXP_DOC_TAB_OUTSOURCE';
  static EXP_DOC_TAB_WORKERS = 'EXP_DOC_TAB_WORKERS';
  static EXP_DOC_TAB_MACHINES = 'EXP_DOC_TAB_MACHINES';
  static EXP_DOC_TAB_MONTHLY = 'EXP_DOC_TAB_MONTHLY';
  static EXP_DOC_TAB_LINKED = 'EXP_DOC_TAB_LINKED';

  static REMOVE_TAB_COMPANIES = 'REMOVE_TAB_COMPANIES';
  static REMOVE_TAB_WORKERS = 'REMOVE_TAB_WORKERS';
  static REMOVE_TAB_MACHINES = 'REMOVE_TAB_MACHINES';

  static PAPER_BIN_TAB_COMPANIES = 'PAPER_BIN_TAB_COMPANIES';
  static PAPER_BIN_TAB_WORKERS = 'PAPER_BIN_TAB_WORKERS';
  static PAPER_BIN_TAB_MACHINES = 'PAPER_BIN_TAB_MACHINES';

  static NOTIFICATIONS = 'NOTIFICATIONS';

  static OUTSOURCES_DASHBOARD = 'OUTSOURCES_DASHBOARD';
  static MESSAGES_DASHBOARD = 'MESSAGES_DASHBOARD';

    static OUTSOURCE_FORM = 'OUTSOURCE_FORM';

  static KEY = "STATE_";
  static DEFAULT_STATE = { page: 1, search: '', filter: 0 };

  static getState(key, defaultValues = null) {
    if (!sessionStorage.getItem(this.KEY + key)) {
      if (!defaultValues) {
        return this.DEFAULT_STATE;
      }
      return {...this.DEFAULT_STATE, ...defaultValues}
    }
    return JSON.parse(sessionStorage.getItem(this.KEY + key));
  }

  static saveState(key, value = {}) {
    sessionStorage.setItem(this.KEY + key, JSON.stringify(value));
  }

  static clearDashboard() {
    this.saveState(this.DOC_ALL_WORKERS_DASHBOARD, this.DEFAULT_STATE);
    this.saveState(this.DOC_ALL_MACHINES_DASHBOARD, this.DEFAULT_STATE);
    this.saveState(this.DOC_MONTHLY_DASHBOARD, this.DEFAULT_STATE);
    this.saveState(this.DOC_OUTOSOURCE_DASHBOARD, this.DEFAULT_STATE);
    this.saveState(this.DOC_LINKED_DASHBOARD, this.DEFAULT_STATE);
    this.saveState(this.DOC_ALL_COMPANY_DASHBOARD, this.DEFAULT_STATE);
    this.saveState(this.DOC_ALL_DASHBOARD, this.DEFAULT_STATE);
  }

  static clearExportDocs() {
    this.saveState(this.EXP_DOC_TAB_OUTSOURCE, this.DEFAULT_STATE);
    this.saveState(this.EXP_DOC_TAB_WORKERS, this.DEFAULT_STATE);
    this.saveState(this.EXP_DOC_TAB_MACHINES, this.DEFAULT_STATE);
    this.saveState(this.EXP_DOC_TAB_MONTHLY, this.DEFAULT_STATE);
    this.saveState(this.EXP_DOC_TAB_LINKED, this.DEFAULT_STATE);
  }

  static clearRemove() {
    this.saveState(this.REMOVE_TAB_COMPANIES, this.DEFAULT_STATE);
    this.saveState(this.REMOVE_TAB_WORKERS, this.DEFAULT_STATE);
    this.saveState(this.REMOVE_TAB_MACHINES, this.DEFAULT_STATE);
  }

  static clear() {
    sessionStorage.clear();
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/utils/StateManager.js